import axios from 'axios';
import i18next from 'i18next';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const localimg = process.env.REACT_APP_LOCALHOST_IMG;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slides, setSlides] = useState([]);
  const [loading, setloading] = useState(true);

  const fetchSlides = async () => {
    try {
      const res = await axios.get(localhost + 'all-carousels');
      const data = res.data;
      const updatedData = data.map(item => {
        const title = item.title ? JSON.parse(item.title) : null;
        const details = item.details ? JSON.parse(item.details) : null;
        return { ...item, title, details };
      });
      setSlides(updatedData);
    } catch (error) {
      // console.error("Error fetching carousels:", error);
    } finally {
      setloading(false);
    }
  }

  useEffect(() => {
    fetchSlides();
  }, [])


  useEffect(() => {
    if (slides.length > 0) {
      const timer = setInterval(() => {
        setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
      }, 5000);

      return () => clearInterval(timer);
    }
  }, [slides]);

  if (loading) {
    return (
      <div className="min-h-[60vh] md:min-h-[80vh] flex justify-center items-center">
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] md:min-h-[80vh] text-white relative">
      {slides.map((slide, index) => (
        <div key={index} className={`absolute inset-0 w-full transition-opacity duration-1000 ease-in-out ${currentSlide === index ? "opacity-100" : "opacity-0"}`}>
          <div className="w-full min-h-[60vh] md:min-h-[80vh] bg-cover bg-center flex items-center justify-center relative" style={{ backgroundImage: `url(${localimg + slide.image})` }}>
            <div className="absolute inset-0 bg-black/40" />
            <div className="relative z-10 text-center px-4">
              <h1 className="text-xl md:text-2xl lg:text-3xl font-bold mb-1 animate-fade-in">{t(slide.title[i18next.language])}</h1>
              <p className="text-base mb-4 max-w-2xl mx-auto">{t(slide.details[i18next.language])}</p>
              <a href="/shop" className="bg-white text-black px-5 py-2 rounded-full text-sm md:text-base font-medium hover:bg-white/80 transition-colors duration-300">
                {t("shop-now")}
              </a>
            </div>
          </div>
        </div>
      ))}

      {/* Dots Navigation */}
      <div className="absolute bottom-4 left-0 right-0 flex justify-center gap-1">
        {slides.map((_, index) => (
          <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${currentSlide === index ? "bg-white w-7" : "bg-white/50"}`} />
        ))}
      </div>
    </div>
  );
}
